import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Augustin Ursu
 * id FDA284E5-BF4A-47DC-B68F-255E07DB89CF
 * name currency-kzt
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-kzt.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const CurrencyKztIcon = createSvgIcon(<><path d="M5,3H19V5H5V3M5,6H19V8H13V21H11V8H5V6Z" /></>, 'CurrencyKztIcon');
export default CurrencyKztIcon